export class ListResults {
    data: any[];
    totalCount: number;

    constructor() {
        this.data = [];
        this.totalCount = 0;
    }
}
